import React from "react";
import style from "./style.module.css";

class OptionDiv extends React.Component {
  constructor(props) {
    super(props);

    this.setHoverState = this.setHoverState.bind(this);

    this.state = {
      isHovered: false
    };
  }

  setHoverState(value) {
    this.setState({
      isHovered: value
    });
  }

  render() {
    const { option, isActive, onClick, isDisabled } = this.props;
    const { isHovered } = this.state;
    const isLayersTab = () => {
      return option.name === "layers";
    };
    const usesLargeIcon = option.name === "layers" || option.name === "resize";
    const iconSize = usesLargeIcon ? "24px" : "20px";

    if (isActive) {
      return (
        <div
          className={
            isLayersTab()
              ? `${style.layerOptionDivActive} notranslate`
              : `${style.optionDivActive} notranslate`
          }
          onClick={onClick}
          onMouseLeave={() => this.setHoverState(false)}
        >
          <div className={style.optionDivActiveRoundedUpCorner} />
          <div className={style.optionDivActiveRoundedDownCorner} />
          {<option.icon size={iconSize} color="white" />}
          <span className="translate">{option.title}</span>
          {isLayersTab() && <span>& Inputs</span>}
        </div>
      );
    } else {
      return (
        <div
          className={
            isLayersTab()
              ? `${style.layerOptionDiv} notranslate`
              : `${style.optionDiv} notranslate`
          }
          onClick={onClick}
          data-disabled={isDisabled}
          onMouseOver={() => this.setHoverState(true)}
          onMouseLeave={() => this.setHoverState(false)}
          data-is-hovered={isHovered}
        >
          {<option.icon size={iconSize} color="#8F9295" />}
          <span className="translate">{option.title}</span>
          {isLayersTab() && <span>& Inputs</span>}
        </div>
      );
    }
  }
}

export default OptionDiv;
